import * as React from "react";
import { Box, Typography } from "@mui/material";
import type { DashboardSummary } from "../types/dashboard";
import { useHeart } from "../../../contexts/HeartContext";

type Props = {
  activity: DashboardSummary["activity"];
};

export default function ActivityCard({ activity }: Props) {
  const { balance: hearts } = useHeart();
  const stats = [
    { value: activity.totalCardsThisWeek, label: "받은 카드" },
    { value: activity.openedCardsThisWeek, label: "열린 카드" },
    { value: activity.activeChats, label: "진행 중 대화" },
    { value: hearts, label: "보유 하트" },
  ];

  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "18px",
        border: "1px solid #E2E8F0",
        p: "22px",
      }}
    >
      <Typography
        sx={{
          fontFamily: '"Playfair Display", serif',
          fontSize: "16px",
          fontWeight: 700,
          color: "#0D1F3C",
          mb: "16px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        📊 이번 주 활동
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
        }}
      >
        {stats.map((stat, i) => (
          <Box
            key={i}
            sx={{
              bgcolor: "#F0F3F8",
              borderRadius: "12px",
              p: "14px",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontSize: "26px",
                fontWeight: 700,
                color: "#0D1F3C",
                lineHeight: 1,
              }}
            >
              {stat.value}
            </Typography>
            <Typography
              sx={{ fontSize: "11px", color: "#8896AB", mt: "4px" }}
            >
              {stat.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
